import * as userApi from "../api/user";
import { initiateVirtualCardCreation } from '../api/api';
import {
  setUser,
  setDashboard,
  setUserAndDashboard,
} from "../redux/slices/userSlice";
// import { startLoading, stopLoading } from '../redux/slices/loadingSlice';

export const referralLeaderboard = async (perPage, page, searchQuery) => {
  try {
    const response = await userApi.referralLeaderboard(perPage, page, searchQuery);
    // console.log(response.data)
    return response.data;
  } catch (error) {
    // console.error('Error fetching referral leaderboard:', error);
    throw error;
  }
};
